export function storeSearchRedirectTerm(query: string) {
    window.sessionStorage.setItem('searchRedirectTerm', query);
}
